import { useLotSizingsQuery } from '@/features/lot-sizings/hooks/use-lot-sisings-query';
import { useLotSizingsTableColumns } from '@/features/lot-sizings/hooks/use-lot-sizings-table-columns';
import { useDataTable } from '@/hooks/use-data-table';
import type { LotSizing } from '@/types/core/lot-sizing/lot-sizing';
import type { ExtendedColumnSort } from '@/types/data-table';

export const defaultSorting: ExtendedColumnSort<LotSizing>[] = [
  { id: 'createdAt', desc: true },
];

export function useLotSizingsTable() {
  const columns = useLotSizingsTableColumns();
  const { lotSizings, isPending } = useLotSizingsQuery();

  const dataTable = useDataTable<LotSizing>({
    data: lotSizings.data,
    columns,
    pageCount: lotSizings.maxPage,
    initialState: {
      sorting: defaultSorting,
    },
  });

  return {
    ...dataTable,
    isPending,
  };
}
